/**
 * Screens that open as a full-screen overlay with no app shell: no sidebar and
 * no phone bottom nav. Settings is an overlay too but keeps the phone nav.
 */
const FULL_SCREEN_PATHS = ['/store/theme'];

export const isFullScreenOverlay = (pathname) => FULL_SCREEN_PATHS.includes(pathname);
